import React from "react";
import classNames from "classnames";
import { Props } from "./types";
import { NumberInput } from "./numberInput";
import styles from "./styles.scss";

function NumberForm({ value, readOnly, disabled, edit, submit }: Props) {
  return readOnly ? (
    <div className={classNames(styles.numberForm, styles.readOnly)}>
      <p className={styles.input}>
        {!!value && !isNaN(parseFloat(value)) ? parseFloat(value) : ""}
      </p>
    </div>
  ) : (
    <form
      className={styles.numberForm}
      onSubmit={(e) => {
        e.preventDefault();
        submit(value);
      }}
    >
      <NumberInput
        value={parseFloat(value)}
        placeholder="-"
        className={classNames(styles.input, { [styles.disabled]: disabled })}
        isDisabled={disabled}
        input={(nbr) => edit(`${nbr}`)}
        blur={() => submit(value)}
      />
    </form>
  );
}

export { NumberForm };
